<template>
    <PortalAuth>
        <div class="d-flex align-items-center min-vh-100">
            <CContainer fluid>
                <CRow class="justify-content-center">
                    <CCol lg="6" md="8" sm="10" style="max-width: 500px">
                        <CCard class="mx-4 mb-0">
                            <CCardBody class="p-4">
                                <CForm v-if="!passworedWasChanged" @submit.prevent="onSubmit">
                                    <h2 class="mb-4" style="text-align:center">Password change</h2>
                                    <CInput
                                        v-model="newPassword1"
                                        placeholder="Password"
                                        type="password"
                                        autocomplete="off"
                                    >
                                        <template #prepend-content>
                                            <CIcon name="cilLockLocked"/>
                                        </template>
                                    </CInput>
                                    <CInput
                                        v-model="newPassword2"
                                        placeholder="Repeat password"
                                        type="password"
                                        autocomplete="off"
                                        class="mb-4"
                                    >
                                        <template #prepend-content>
                                            <CIcon name="cilLockLocked"/>
                                        </template>
                                    </CInput>
                                    <FormErrors :errors="errors"/>
                                    <div class="mt-4" style="text-align:center">
                                        <CButton type="submit" color="success" :disabled="this.graphqlLoadingFlag">Confirm my password</CButton>
                                    </div>
                                </CForm>
                                <p v-if="passworedWasChanged">Password was changed successfully.
                                    You can
                                    <CLink :to="{name: 'login'}">login</CLink>
                                    with new password now.
                                </p>
                            </CCardBody>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </div>
    </PortalAuth>
</template>

<script>
    import {
        getProcessedAuthResponseErrorsFlat,
        getResetPasswordMutation
    } from '@/scripts/auth-utils'
    import {onSubmitHandler} from '@/scripts/forms-utils'

    import PortalAuth from '@/components/layouts/PortalAuth'
    import FormErrors from '@/components/FormErrors'

    export default {
        components: {PortalAuth, FormErrors},
        data() {
            return {
                newPassword1: '',
                newPassword2: '',
                coach: false,
                errors: [],
                graphqlLoadingFlag: false,
                passworedWasChanged: false,
            }
        },
        methods: {
            async onSubmit() {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                const token = urlParams.get('token')
                let mutation = getResetPasswordMutation(token, this.newPassword1, this.newPassword2)
                await onSubmitHandler(this, mutation,
                    {
                        setErrorsF: (errors, scope) => scope.errors = getProcessedAuthResponseErrorsFlat(errors),
                        onSuccessF: (res, scope) => scope.passworedWasChanged = true
                    })
            }
        }
    }
</script>